import { render, staticRenderFns } from "./twoPlus.vue?vue&type=template&id=eff5609c&"
import script from "./twoPlus.vue?vue&type=script&lang=js&"
export * from "./twoPlus.vue?vue&type=script&lang=js&"
import style0 from "./twoPlus.vue?vue&type=style&index=0&id=eff5609c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports